<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ formData.title }}</h2>
                </v-row>

                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-subheader class="blue--text">{{$t('reportsparam.parameters')}}</v-subheader>
                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n5 ">
                            <v-autocomplete
                            outlined
                            :label="this.$t('pmrewardposting.rewardsimulationdesc')"
                            type="text"
                            :rules="[rules.required]"
                            :items="rewardSimulationList"
                            v-model="formData.rewardsimulationid"
                            @change="changeRewardSimulation(formData.rewardsimulationid)"
                            dense
                            ></v-autocomplete>                    
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-1">
                            <v-text-field
                            outlined
                            :label="this.$t('pmrewardposting.rewardsimulationcode')"
                            type="text"
                            v-model="formData.simulationcode"
                            readonly
                            background-color="#ffeab2"
                            dense
                        ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-6 pb-4">
                        <v-row>
                            <v-col>
                                <v-btn 
                                    color="warning" 
                                    style="width: 100px"
                                    @click="goHandler" 
                                > 
                                {{$t('button.go')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
export default {

    data() {
        return{
            rules: {
                required: (value) => !!value || this.$t('reportsparam.required'),
            },

            formData:{
                rewardsimulationid: null,
                simulationcode: null,
                rewardsimulationname: null,
                title: this.getTitle()
            },

            rewardSimulationList: [],
            isErr: false,
            errMsg: "",

            activeStaff: true,
        }
    },

    watch: {
    '$route.name'(newVal) {
        console.log("Route Name Changed", newVal);
        this.formData.title = this.getTitle();
    }
    },

    methods: {
        goHandler() {
            if (this.$route.name === 'pmrewardbonusenquiry') {
                this.$router.push({name: 'bonusenquirydetails', params: { rewardsimulationid: this.formData.rewardsimulationid, rewardsimulationname: this.formData.rewardsimulationname} });
            } else if (this.$route.name === 'pmrewardincrementenquiry') {
                this.$router.push({name: 'incrementenquirydetails', params: { rewardsimulationid: this.formData.rewardsimulationid, rewardsimulationname: this.formData.rewardsimulationname} });
            }
        },

        getTitle() {
            if (this.$route.name === 'pmrewardbonusenquiry') {
            return 'Reward Bonus Enquiry';
            }
            if (this.$route.name === 'pmrewardincrementenquiry') {
            return 'Performance Salary Increment Enquiry';
            }
            return '';
        },

        changeRewardSimulation(id) {
            let item = this.rewardSimulationList.find((item) => item.id == id);
    
            this.formData.simulationcode = item.simulationcode;
            this.formData.rewardsimulationname = item.simulationdesc;
        },

        loadRewardSimulationHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/rewardsimulation/all"})
            .then((res) => {

            for (let i = 0; i < res.data.rec.length; i++) {
                
                vm.rewardSimulationList.push({
                text: res.data.rec[i].simulationdesc,
                value: res.data.rec[i].id,
                code: res.data.rec[i].simulationcode,
                ...res.data.rec[i], // Add the rest of the properties from res.data.rec[i]
                });
            }

            })
            .catch((err) => {
            vm.isErr = true;
            vm.errMsg = err;
            });
        },
    },

    mounted(){
        this.loadRewardSimulationHandler();
    },

}
</script>